// biome-ignore lint/style/noRestrictedImports: encapsulation
import { concat as concat_ } from "remeda";

import { unpurry } from "./_unpurry";

export const concat = unpurry(concat_, 2);
